import React from 'react';
import { Mail, MapPin, Linkedin, Github } from 'lucide-react';
import { FaMedium } from 'react-icons/fa';

import './Contacts.css';
import { theme } from '../../theme/designSystem';
import { socialsData } from '../../data/socialsData';
import { contactsData } from '../../data/contactsData';

function Contacts() {
    return (
        <section className="contacts" id="contacts">
            <div className="contacts--container">
                <div className="contacts--header">
                    <span className="eyebrow eyebrow--center">Contact</span>
                    <h2 style={{ color: theme.primary }}>Let's build something significant</h2>
                    <p style={{ color: theme.textSecondary }}>
                        Open to discussing technology leadership roles, advisory engagements, and technical partnerships.
                    </p>
                </div>

                <div className="contacts--content">
                    <div className="contacts--info">
                        <a
                            href={`mailto:${contactsData.email}`}
                            className="contacts--item"
                            style={{ backgroundColor: theme.cardBg, borderColor: theme.border }}
                        >
                            <div className="contacts--icon" style={{ backgroundColor: theme.accent }}>
                                <Mail size={20} color="#FFF" />
                            </div>
                            <div className="contacts--details">
                                <span className="contacts--label" style={{ color: theme.textSecondary }}>Email</span>
                                <span className="contacts--value" style={{ color: theme.primary }}>
                                    {contactsData.email}
                                </span>
                            </div>
                        </a>

                        <div
                            className="contacts--item"
                            style={{ backgroundColor: theme.cardBg, borderColor: theme.border }}
                        >
                            <div className="contacts--icon" style={{ backgroundColor: theme.accent }}>
                                <MapPin size={20} color="#FFF" />
                            </div>
                            <div className="contacts--details">
                                <span className="contacts--label" style={{ color: theme.textSecondary }}>Location</span>
                                <span className="contacts--value" style={{ color: theme.primary }}>
                                    {contactsData.address}
                                </span>
                            </div>
                        </div>
                    </div>

                    <div className="contacts--socials">
                        {socialsData.linkedIn && (
                            <a
                                href={socialsData.linkedIn}
                                target="_blank"
                                rel="noreferrer"
                                className="contacts--social"
                                style={{ backgroundColor: theme.cardBg, borderColor: theme.border }}
                                aria-label="LinkedIn"
                            >
                                <Linkedin size={24} style={{ color: theme.primary }} />
                            </a>
                        )}
                        {socialsData.github && (
                            <a
                                href={socialsData.github}
                                target="_blank"
                                rel="noreferrer"
                                className="contacts--social"
                                style={{ backgroundColor: theme.cardBg, borderColor: theme.border }}
                                aria-label="GitHub"
                            >
                                <Github size={24} style={{ color: theme.primary }} />
                            </a>
                        )}
                        {socialsData.medium && (
                            <a
                                href={socialsData.medium}
                                target="_blank"
                                rel="noreferrer"
                                className="contacts--social"
                                style={{ backgroundColor: theme.cardBg, borderColor: theme.border }}
                                aria-label="Medium"
                            >
                                <FaMedium size={24} style={{ color: theme.primary }} />
                            </a>
                        )}
                    </div>
                </div>
            </div>
        </section>
    );
}

export default Contacts;
